'use strict';

var ScheduleChangePanelConfig = function ScheduleChangePanelConfig($stateProvider) {
  $stateProvider.state('app.schedule-change', {
    url: '/workflow/schedule-change',
    ifFeatureEnabled: ['REVENUE_OPTIMIZER'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/schedule-change-panel.html'),
        controller: 'ScheduleChangePanelController'
      },
      'mainToolbar': {
        template: require('../templates/schedule-change-toolbar.html'),
        controller: 'ScheduleChangeToolbarController'
      }
    }
  });
};
module.exports = ScheduleChangePanelConfig;
ScheduleChangePanelConfig.$inject = ['$stateProvider'];